import * as disptachItemActions from "./dispatchItem.action";
const { v4: uuidv4 } = require("uuid");

const initialState = {
  dispatchItemDetails: [
    {
      rowId: uuidv4(),
      token: "",
      noOfPieces: "",
      itemPurity: "",
      itemWeight: "",
      itemPureWeight: "",
    },
  ],
  totalDispatchedItemDetails: {
    totalWeight: 100,
    totalPureWeight: 99.5,
  },
};

export const dispatchItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case disptachItemActions.CREATE_PURITY:
      return {
        ...state,
        dispatchItemDetails: [
          ...state.dispatchItemDetails,
          {
            rowId: uuidv4(),
            token: "",
            noOfPieces: "",
            itemPurity: "",
            itemWeight: "",
            itemPureWeight: "",
          },
        ],
      };
    case disptachItemActions.UPDATE_PURITY:
      return {
        ...state,
        dispatchItemDetails: action.payload,
      };
    case disptachItemActions.DELETE_PURITY:
      return {
        ...state,
        dispatchItemDetails: state.dispatchItemDetails.filter(
          (item) => item.rowId !== action.payload
        ),
      };
    case disptachItemActions.TOTALDISPATCH_PURITY:
      return {
        ...state,
        totalDispatchedItemDetails: action.payload,
      };
    default:
      return { ...state };
  }
};
